import React from 'react';
import PropTypes from 'prop-types';

const FavoritesIcon = ({ className, filled, isLoading}) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            className={`fill-current ${className}`}
            // fill="currentColor"
            fill={filled ? 'currentColor' : 'none'}  // ✅ Ensure correct SVG fill

        >
            {filled ? (
                <path d="M13.8809 1.6665C12.2454 1.6665 10.7817 2.46164 9.86908 3.68144C8.95648 2.46164 7.49272 1.6665 5.85728 1.6665C3.08336 1.6665 0.833496 3.9254 0.833496 6.71739C0.833496 7.79263 1.00517 8.78654 1.30335 9.70817C2.73097 14.226 7.1313 16.9276 9.30887 17.6685C9.61608 17.7769 10.1221 17.7769 10.4293 17.6685C12.6069 16.9276 17.0072 14.226 18.4348 9.70817C18.733 8.78654 18.9047 7.79263 18.9047 6.71739C18.9047 3.9254 16.6548 1.6665 13.8809 1.6665Z" fill="currentColor"/>
            ) : (
                <path fillRule="evenodd" clipRule="evenodd" d="M6.29984 3.2085C4.0896 3.2085 2.2915 5.00908 2.2915 7.24183C2.2915 9.95059 3.54207 12.1209 5.11586 13.7334C6.69719 15.3536 8.56646 16.3685 9.68509 16.7503L9.69119 16.7524L9.69118 16.7525C9.74515 16.7715 9.85702 16.7918 9.99984 16.7918C10.1427 16.7918 10.2545 16.7715 10.3085 16.7525L10.3146 16.7503L10.3146 16.7503C11.4332 16.3685 13.3025 15.3536 14.8838 13.7334C16.4576 12.1209 17.7082 9.95059 17.7082 7.24183C17.7082 5.00908 15.9101 3.2085 13.6998 3.2085C12.398 3.2085 11.2307 3.84109 10.5016 4.8228C10.3837 4.98157 10.1976 5.07516 9.99984 5.07516C9.80208 5.07516 9.61598 4.98157 9.49807 4.8228C8.76863 3.84058 7.6094 3.2085 6.29984 3.2085ZM1.0415 7.24183C1.0415 4.32458 3.39341 1.9585 6.29984 1.9585C7.74712 1.9585 9.05364 2.54682 10.0001 3.49576C10.9486 2.54653 12.26 1.9585 13.6998 1.9585C16.6063 1.9585 18.9582 4.32458 18.9582 7.24183C18.9582 10.3664 17.5087 12.8336 15.7784 14.6065C14.0568 16.3704 12.0194 17.4886 10.7212 17.9324C10.4926 18.0124 10.2309 18.0418 9.99984 18.0418C9.76877 18.0418 9.50704 18.0124 9.27846 17.9324C7.98029 17.4886 5.94291 16.3704 4.22131 14.6065C2.49094 12.8336 1.0415 10.3664 1.0415 7.24183Z" fill="currentColor"/>
            )}
        </svg>
    );
};

FavoritesIcon.propTypes = {
    className: PropTypes.string,
    filled: PropTypes.bool.isRequired, 
    isLoading: PropTypes.bool, 
};

FavoritesIcon.defaultProps = {
    className: '', 
    isLoading: false,
};

export default FavoritesIcon;